import * as Yup from 'yup';

export const CreateDripScheduleFormValidationSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required(`Please enter a name for the drip schedule.`)
    });
};
